import { Box, Column, Columns } from 'braid-design-system';
import type { ReactNode } from 'react';

import JobCount from '../Recommendations/JobCount.tsx';
import { JOB_COUNT_PADDING } from '../Recommendations/RecommendationsContent/RecommendationsContent';

import NewRecommendationButton from './NewRecommendationButton/NewRecommendationButton';

import * as styles from './SplitViewLayout.css';

const outerSpacing = ['none', 'none', 'xxlarge'] as const;

// todo [to be cleaned up] here is a dirty hack to create exact same spacing to align right and left side of the split view;
const SearchResultsHeaderSpacer = () => (
  <Box opacity={0} {...JOB_COUNT_PADDING}>
    <JobCount />
  </Box>
);

const SplitViewLayout = ({
  ListView,
  DetailView,
  clickedJobCount,
  totalJobCount,
  hasSelectedJob,
}: {
  ListView: ReactNode;
  DetailView: ReactNode;
  clickedJobCount: number;
  totalJobCount?: number;
  hasSelectedJob: boolean;
}) => (
  <Box
    width="full"
    data-automation="splitViewParentWrapper"
    className={styles.splitViewWrapper}
  >
    <Columns collapseBelow="desktop" space={outerSpacing}>
      <Column width="2/5">
        <Box
          position="relative"
          display="flex"
          flexDirection="column"
          paddingBottom={outerSpacing}
        >
          <Box className={styles.jobListWrapperStyles}>{ListView}</Box>
          {clickedJobCount >= 3 && (
            <Box
              className={styles.floatingButtonWrapper}
              marginTop="xlarge"
              display={{ mobile: 'none', tablet: 'none', desktop: 'flex' }}
              justifyContent="center"
            >
              <NewRecommendationButton totalJobCount={totalJobCount} />
            </Box>
          )}
        </Box>
      </Column>
      <Column>
        <Box
          background="surface"
          height="full"
          display={{ mobile: 'none', tablet: 'none', desktop: 'block' }}
          paddingBottom={hasSelectedJob ? 'none' : outerSpacing}
          className={styles.jobDetailsWrapper}
        >
          <SearchResultsHeaderSpacer />

          <Box
            data-automation="splitModeJobDetailsWrapper"
            className={styles.jobDetailsIndependentScrollSession}
            paddingBottom={outerSpacing}
            height="full"
          >
            {DetailView}
          </Box>
        </Box>
      </Column>
    </Columns>
  </Box>
);
export default SplitViewLayout;
